import $ from "jquery";

export const adjustTables = (table) =>{

    var tableClassName = "." + table;
    var maxTableHeight = 460;

    function adjustTable(){
        let isIE = /*@cc_on!@*/false || !!document.documentMode;
        let isFirefox = typeof InstallTrigger !== 'undefined';
        let parentwidth = $(tableClassName+" .tbody-fixed.table-responsive").width();     
        $(tableClassName+" thead.table-header").css("maxWidth", parentwidth + 1)
        $(tableClassName+" th.fixed-header" ).each(function(index) {
            let colId = `${tableClassName} td#col${index}`;
            let headId = `${tableClassName} th#head${index}`;
            let colWidth = $(colId).innerWidth();
            

            if($(this).hasClass("lasthead")){
                $(headId).css("maxWidth", colWidth + 18)
                $(headId).css("minWidth", colWidth + 18)
                $(headId).css("width", colWidth + 18)
                if($(`#${table}`).height() < maxTableHeight){
                    $(headId+" center div").css("margin-left", -10)
                }
            }else{
                if(!$(this).hasClass("table-checkbox-header")){
                    $(headId).css("white-space","pre-wrap");
                }                

                if($(`#${table}`).height() >= maxTableHeight){
                    if(isIE || isFirefox){
                        $(headId).css("maxWidth", colWidth + 0.44)
                        $(headId).css("minWidth", colWidth + 0.44)
                        $(headId).css("width", colWidth + 0.44)
                    }else{
                        $(headId).css("maxWidth", colWidth + 1.67)
                        $(headId).css("minWidth", colWidth + 1.67)
                        $(headId).css("width", colWidth + 1.67)
                    }
                }else{
                    if(isIE || isFirefox){
                        $(headId).css("maxWidth", colWidth + 1)
                        $(headId).css("minWidth", colWidth + 1)
                        $(headId).css("width", colWidth + 1)
                    }else{
                        $(headId).css("maxWidth", colWidth + 1.67)
                        $(headId).css("minWidth", colWidth + 1.67)
                        $(headId).css("width", colWidth + 1.67)
                    }
                }
            }
        });
    }
    
    $( window ).resize(function() {
        adjustTable();
    });

    $(document).ready(function () {
        adjustTable();
        (function() {
            let target = $(".thead-fixed.table-responsive"+tableClassName);
            $(".tbody-fixed.table-responsive"+tableClassName).scroll(function() {
                target.prop("scrollTop", this.scrollTop)
                    .prop("scrollLeft", this.scrollLeft);
            });
        })();
    });
}

